import React from "react";
import { utilityFns } from "../utility-functions";
import cn from "classnames";

import "./checkbox.scss";

const Checkbox = (props) => {
  const checked = String(props.value).toLowerCase() === "true";
  const className = props.className;
  const propsForInput = { ...props };
  delete propsForInput.key;
  delete propsForInput.appearanceDisabled;
  const randomKey = Math.random();

  const handleClick = (e) => {
    if (props.disabled) return;
    // Prevent default to avoid any unwanted behavior
    e.preventDefault();

    // Create a synthetic event to maintain compatibility with existing onChange handlers
    const syntheticEvent = {
      target: {
        type: "checkbox",
        name: props.name,
        checked: !checked,
        value: !checked,
      },
    };

    props.onChange(syntheticEvent);
  };

  return (
    <div
      className={`main-checkbox ${className} ${
        utilityFns.strToBoolean(props.isgreyed) ? "greyscale" : undefined
      } ${
        props.appearanceDisabled && !props.disabled
          ? "appearance-disabled-wrap"
          : undefined
      } ${
        !utilityFns.strToBoolean(props.agreementstep)
          ? undefined
          : checked
          ? "unchecked-transparent"
          : "checked-yellow"
      }`}
    >
      <input
        id={randomKey}
        type="checkbox"
        {...propsForInput}
        checked={checked}
      />
      <label
        onClick={handleClick}
        htmlFor={randomKey}
        className={cn({
          disabled: props.disabled,
          "appearance-disabled": props.appearanceDisabled && !props.disabled,
        })}
      >
        {props.placeholder}
      </label>
      {props.tooltip || null}
    </div>
  );
};

export default Checkbox;
